import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import { globalColors } from "../../Utils/colors";

const SearchIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.27293 2.6211C4.42783 2.6211 2.12142 4.92751 2.12142 7.77261C2.12142 10.6177 4.42783 12.9241 7.27293 12.9241C10.118 12.9241 12.4244 10.6177 12.4244 7.77261C12.4244 4.92751 10.118 2.6211 7.27293 2.6211ZM0.788086 7.77261C0.788086 4.19113 3.69145 1.28777 7.27293 1.28777C10.8544 1.28777 13.7578 4.19113 13.7578 7.77261C13.7578 11.3541 10.8544 14.2575 7.27293 14.2575C3.69145 14.2575 0.788086 11.3541 0.788086 7.77261Z"
        fill="#A1A1A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9106 11.4101C11.1709 11.1498 11.5931 11.1498 11.8534 11.4101L15.017 14.5737C15.2774 14.8341 15.2774 15.2562 15.017 15.5166C14.7567 15.7769 14.3346 15.7769 14.0742 15.5166L10.9106 12.3529C10.6502 12.0926 10.6502 11.6705 10.9106 11.4101Z"
        fill="#A1A1A1"
      />
    </svg>
  );
};

const CloseIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00016 7.0572L11.5288 3.52861C11.7891 3.26826 12.2112 3.26826 12.4716 3.52861C12.7319 3.78896 12.7319 4.21107 12.4716 4.47141L8.94297 8.00001L12.4716 11.5286C12.7319 11.789 12.7319 12.2111 12.4716 12.4714C12.2112 12.7318 11.7891 12.7318 11.5288 12.4714L8.00016 8.94282L4.47157 12.4714C4.21122 12.7318 3.78911 12.7318 3.52876 12.4714C3.26841 12.2111 3.26841 11.789 3.52876 11.5286L7.05735 8.00001L3.52876 4.47141C3.26841 4.21107 3.26841 3.78896 3.52876 3.52861C3.78911 3.26826 4.21122 3.26826 4.47157 3.52861L8.00016 7.0572Z"
        fill="#A1A1A1"
      />
      <mask
        id="mask0_407_2627"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="10"
        height="10"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00016 7.0572L11.5288 3.52861C11.7891 3.26826 12.2112 3.26826 12.4716 3.52861C12.7319 3.78896 12.7319 4.21107 12.4716 4.47141L8.94297 8.00001L12.4716 11.5286C12.7319 11.789 12.7319 12.2111 12.4716 12.4714C12.2112 12.7318 11.7891 12.7318 11.5288 12.4714L8.00016 8.94282L4.47157 12.4714C4.21122 12.7318 3.78911 12.7318 3.52876 12.4714C3.26841 12.2111 3.26841 11.789 3.52876 11.5286L7.05735 8.00001L3.52876 4.47141C3.26841 4.21107 3.26841 3.78896 3.52876 3.52861C3.78911 3.26826 4.21122 3.26826 4.47157 3.52861L8.00016 7.0572Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_407_2627)"></g>
    </svg>
  );
};

export default function SearchBox({
  value,
  setValue,
  clearHandler,
  placeHolder,
}: any) {
  return (
    <FormControl
      sx={{ backgroundColor: globalColors.white, width: 250 }}
      variant="outlined"
    >
      <OutlinedInput
        sx={{ height: 40, fontFamily: "Poppins", fontSize: "12px" }}
        value={value}
        placeholder={placeHolder}
        onChange={(event) => {
          setValue(event.target.value);
        }}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        endAdornment={
          value.length ? (
            <InputAdornment position="end">
              <div
                style={{
                  alignItems: "center",
                  cursor: "pointer",
                  display: "flex",
                }}
                onClick={clearHandler}
              >
                <CloseIcon />
              </div>
            </InputAdornment>
          ) : null
        }
      />
    </FormControl>
  );
}
